import React, { Component } from 'react';
import Buttons from "../Buttons";

class ModalFooter extends Component {
    constructor(props) {
      super(props);
      this.state = {
        buttonList:this.props.buttonList
      }
    }
    componentDidUpdate(prevProps){
      if(prevProps.buttonList !== this.props.buttonList) {
        this.setState({buttonList:this.props.buttonList});
      }
  } //tableRecords
    render () {
      return (
            <div className="modal-footer"> 
                <Buttons buttonList={this.state.buttonList} />
            </div>
            
        )
    }
}

export default ModalFooter;